import Modal, { ModalProps } from '@core/components/Modal/Modal';
import { selectIsAuthenticated } from '@waitroom/auth';
import { ModalState, setModal } from '@waitroom/common';
import { ReactElement, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AuthModalWrapper, { AuthModalWrapperProps } from '../../AuthModalWrapper/AuthModalWrapper';

export interface AuthModalProps extends ModalState<AuthModalWrapperProps>, ModalProps {
  setModal: typeof setModal;
}

const AuthModal = ({ props, isOpen = false, ...rest }: AuthModalProps): ReactElement | null => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const { isSwitchAccounts, onCompleted } = props || {};

  useEffect(() => {
    if (isOpen && isAuthenticated && !isSwitchAccounts) setModal();
  }, [dispatch, isAuthenticated, isOpen, isSwitchAccounts]);

  const onCompletedInternal = useCallback(() => {
    if (isSwitchAccounts) setModal();
    onCompleted?.();
  }, [isSwitchAccounts, onCompleted]);

  return (
    <Modal size="lg" isOpen={isOpen} isCentered {...rest}>
      <Modal.Header />
      <Modal.Body data-id="auth-modal">
        <AuthModalWrapper {...props} onCompleted={onCompletedInternal} />
      </Modal.Body>
    </Modal>
  );
};

export default AuthModal;
